<template>
  <TsSection :data-testid="'news-letter-section' + randomId">
    <TsTypography append-class="text-xl text-center md:text-left text-secondary-black font-bold">
      {{ title }}
    </TsTypography>
    <TsGrid :cols="3" :mobileCols='1'>
      <TsColumn :data-testid="'column-newsletter-benifit-' + randomId" v-for="(item, index) in data" :key="index"
        append-class="w-full py-2">
        <TsNuxtCard appendClass="rounded-full whitespace-normal p-3 px-5" noBorder noShadow>
          <TsRow noGutter class="items-center gap-3">
            <TsColumn :data-testid="'news-letter-column-img-' + randomId" class="is-2 py-0">
              <TsImage class="rounded-full w-full" v-if="item.img" :src="item.img" alt="Card Image 2" loading="lazy"/>
            </TsColumn>
            <TsColumn :data-testid="'news-letter-column-content-' + randomId">
              <TsTypography append-class="mb-0 text-base text-secondary-black" weight="bold"
                :data-testid="'news-letter-title-' + randomId">
                {{ item.title }}
              </TsTypography>
              <TsTypography append-class="mb-0 text-sm" :data-testid="'news-letter-description-' + randomId">
                {{ item.description }}
              </TsTypography>
            </TsColumn>
          </TsRow>
        </TsNuxtCard>
      </TsColumn>
    </TsGrid>
  </TsSection>
</template>

<script setup lang="ts">



const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);

const TsNuxtCard = defineAsyncComponent(
    () => import('~/components/organisms/TsNuxtCard.vue')
);


type Data = {
  key: number;
  img: string;
  title: string;
  description: string;
}

type Props = {
  title: string;
  data?: Data[];
  dataTestid?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Benefits of Newsletter',
  data: () => ([
    {
      key: 1,
      img: '/images/Discount.svg',
      title: "Exclusive Discount and Offers",
      description: 'Be the first to know about sales events and new product launches.'
    },
    {
      key: 2,
      img: '/images/Update.svg',
      title: "Stay Updated About Latest Tools",
      description: 'Receive updates on the latest and most innovative tools in the market.'
    },
    {
      key: 3,
      img: '/images/Experts.svg',
      title: "Expert Tips and Advice",
      description: 'Get expert tips on using and maintaining your tools.'
    }
  ])
});

// random ID for each Vue Instance
const randomId: Ref<string> = ref("");

onMounted(() => {
  randomId.value = useRandomUUID();
});
</script>
